module.exports = __webpack_public_path__ + "img/UI_loading_chip_864cddf88.png";